import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

const messages = defineMessages({
  title_block: {
    id: 'tag',
    defaultMessage: 'Tag',
  },
  no_tags: {
    id: 'no_tags',
    defaultMessage: 'Non ci sono tag impostati',
  },
});

const Body = (props) => {
  const { isEditMode = false } = props;
  const intl = useIntl();
  const tags =
    props?.properties?.tags?.length > 0
      ? props.properties.tags
      : props?.subjects?.length > 0
      ? props.subjects
      : [];

  return tags.length > 0 ? (
    <div className="wrapper-page-tag">
      {/* <label>{intl.formatMessage(messages.title_block)}:</label> */}
      <div className="site--chips">
        {tags.map((tag, index) => {
          return (
            <Link
              className="site--chip site--chip-custom"
              to={`/search?Subject=${tag}`}
              key={index}
            >
              {tag}
            </Link>
          );
        })}
      </div>
    </div>
  ) : isEditMode ? (
    <p>{intl.formatMessage(messages.no_tags)}</p>
  ) : (
    <></>
  );
};

export default Body;
